// extracted by mini-css-extract-plugin
module.exports = {"skipButton":"_2kOptfPhT1cNAR8whI-1CN","disclaimer":"_35yX_oU8p7oh8mHdKAZRZ"};